import './sectionCTA.css';

function SectionsCTA({Titulo,cor,srcImg}) {
    return (
      <div className="SectionsCTA">
        <div className='container w-10/12 mx-auto'>
            <div className='columns-1'>
                <h1 className='tituloCTA text-5xl text-white'>{Titulo}</h1>
            </div>
        </div>
      </div>
    );
  }
  
  export default SectionsCTA;